import Vue from "vue";

import CashAndCoupons from "./CashAndCoupons.vue";

export function load() {
    const selector = "my-cash-and-coupons";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(CashAndCoupons, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
